// for pages do not be pre-rendered at build time

import { Spin } from 'antd';
import styles from './article.module.scss';

const ArticleLoading = () => {
  return (
    <div>
      <Spin
        indicator={<div className={styles['spinner']} />}
        spinning
        style={{
          width: '100vw',
          height: 'calc(100vh - 317px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      />
    </div>
  );
};

export default ArticleLoading;
